export default {
	SERVICE_LEAD: 'Schedule Service'
};
